import { render, staticRenderFns } from "./JicaOyo.vue?vue&type=template&id=1e96b512&scoped=true&"
import script from "./JicaOyo.vue?vue&type=script&lang=js&"
export * from "./JicaOyo.vue?vue&type=script&lang=js&"
import style0 from "./JicaOyo.vue?vue&type=style&index=0&id=1e96b512&prod&scoped=true&lang=css&"
import style1 from "./JicaOyo.vue?vue&type=style&index=1&id=1e96b512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96b512",
  null
  
)

export default component.exports